module.exports = __webpack_public_path__ + "img/gift.d19f121c.png";